var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTravel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.30999 9.03L4.26999 11.36C4.56999 11.71 4.56999 12.29 4.26999 12.64L2.30999 14.97C2.03999 15.51 2.30999 16.17 2.88999 16.37L4.21999 16.81C4.53999 16.92 5.00999 16.81 5.24999 16.57L7.52999 14.3C7.68999 14.13 8.00999 14 8.23999 14L11.09 14C11.51 14 11.71 14.31 11.55 14.7L9.42999 19.61C9.09999 20.38 9.50999 21.01 10.35 21.01L11.64 21.01C12.31 21.01 13.08 20.51 13.34 19.89L15.75 14.3C15.82 14.14 16.03 14 16.21 14L19.21 14C20.15 14 21.26 13.31 21.69 12.47C21.84 12.17 21.84 11.82 21.69 11.52C21.26 10.68 20.14 9.99001 19.2 9.99001L16.2 9.99001C16.02 9.99001 15.81 9.85001 15.74 9.69001L13.33 4.11001C13.08 3.49001 12.31 2.99001 11.64 2.99001L10.35 2.99C9.50999 2.99 9.09999 3.62 9.42999 4.39L11.55 9.30001C11.72 9.68001 11.51 10 11.09 10L8.23999 10C8.00999 10 7.68999 9.87001 7.52999 9.71001L5.24999 7.44C5.00999 7.2 4.54999 7.09 4.21999 7.2L2.88999 7.64C2.30999 7.82 2.02999 8.48 2.30999 9.03Z",
    stroke: "#00254A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTravel);
export default __webpack_public_path__ + "static/media/travel.b1308a7224a4dbf818147e3042d4c00d.svg";
export { ForwardRef as ReactComponent };